// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"PrizeRedemptionDescription_mainContainer__NFFaM","title":"PrizeRedemptionDescription_title__N6D_t","subtitle":"PrizeRedemptionDescription_subtitle__dB7iX"};